export const formatDecimal = value => {
    return value.replace(/[^0-9,.]/g, "").replace(",", ".");
};

/**
 * Formata uma data em DD/MM/YYYY sem depender do moment.
 *
 * O cuidado com o fuso e proposital: os gateways devolvem billet_due_date em
 * formatos diferentes ("2026-09-05", "2026-09-05 00:00:00", ISO com offset).
 * new Date('2026-09-05') seria lido como UTC e, em America/Sao_Paulo, voltaria
 * um dia no vencimento do boleto. Data pura e tratada como data local, igual
 * ao moment fazia.
 */
export const formatDateBR = value => {
    if (!value) return "";

    const raw = String(value).trim();

    const dateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnly) {
        const [, year, month, day] = dateOnly;
        return `${day}/${month}/${year}`;
    }

    // 'YYYY-MM-DD HH:mm:ss' vira forma ISO sem offset, que o JS le como hora local
    const date = new Date(raw.replace(" ", "T"));
    if (isNaN(date.getTime())) return "";

    const pad = number => String(number).padStart(2, "0");

    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`;
};
